var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VURL } from "js-vextensions";
import { BaseComponentPlus } from "react-vextensions";
import { manager } from "../../Manager.js";
import { MaybeLog } from "../General/Logging.js";
import { loadingURL, NotifyURLLoaded, LoadURL } from "../URL/URLs.js";
import { e } from "../../PrivateExports.js";
import { Observer } from "../Store/MobX.js";
// this handles: address-bar-change (from user pressing back/forward) -> store-changes
window.addEventListener("popstate", e => {
    //LoadURL(e.state);
    //LoadURL(VURL.FromLocationObject(window.location));
    LoadURL(VURL.Parse(window.location.href));
});
/**
 * This handles address-bar-change (from history.pushState and history.replaceState, eg. from Link components) -> store-changes.
 * (We could monkey-patch history.pushState and history.replaceState to intercept calls, but since the only calls atm are in Link.tsx, it's cleaner to just manually call this.)
*/
export function NotifyCalledHistoryReplaceOrPushState() {
    LoadURL(VURL.Parse(window.location.href));
}
let lastProcessedURL;
let AddressBarWrapper = class AddressBarWrapper extends BaseComponentPlus({}, {}) {
    constructor() {
        super(...arguments);
        this.loadingUI = () => null;
    }
    // the render function handles: store-changes -> address-bar-change
    render() {
        const newURL = manager.GetNewURL();
        const pushURL = !loadingURL && manager.DoesURLChangeCountAsPageChange(lastProcessedURL, newURL);
        // if (pushURL) Log(`Pushing: ${newURL} @oldURL:${lastURL}`);
        if (loadingURL)
            NotifyURLLoaded();
        if (lastProcessedURL && newURL.toString({ domain: false }) === lastProcessedURL.toString({ domain: false }))
            return null;
        if (lastProcessedURL) {
            if (pushURL) {
                history.pushState(null, null, newURL.toString({ domain: false }));
            }
            else {
                history.replaceState(null, null, newURL.toString({ domain: false }));
            }
            MaybeLog(a => a.urlLoads, () => `Dispatching new-url: ${newURL} @push:${pushURL}`);
        }
        else {
            // if page just loaded, do one "start-up" LOCATION_CHANGED action, with whatever's in the address-bar
            /*const startURL = e.GetCurrentURL(true).toString({domain: false});
            //action = replace(startURL);
            history.replaceState(null, null, startURL.toString());*/
            MaybeLog(a => a.urlLoads, () => `Dispatching start-url: ${e.GetCurrentURL()} @push:${pushURL}`);
        }
        // action.byUser = false;
        // g.justChangedURLFromCode = true;
        // action.payload.fromStateChange = true;
        // extend the "state" argument for the to-be-created history-entry (used in ActionProcessor.ts)
        //action.payload.args[1] = E(action.payload.args[1], {fromStateChange: true});
        //manager.store.dispatch(action);
        lastProcessedURL = newURL;
        return null;
    }
};
AddressBarWrapper = __decorate([
    Observer
], AddressBarWrapper);
export { AddressBarWrapper };
//# sourceMappingURL=AddressBarWrapper.js.map